import React, { useEffect, useState } from "react";
import { requiresFreshOfflinePaymentCode } from "../offlinePayment/offlinePaymentRouting";
import { useHistory, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

import { Drawer } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import loaderData from "../../assets/loader.json";
import BackArrow from "../../atoms/backArrow/backArrow";
import rightArrow from "../../assets/images/right_caret.svg";
import FloatingInput from "../../atoms/floatingInput/floatingInput";
import LoaderLight from "../../atoms/loaderLight/loaderLight";
import UserIcon from "../../assets/testRide/userProfileIcon.svg";
import searchIcon from "../../assets/testRide/search-white.svg";
import graySearchIcon from "../../assets/testRide/gray-search.svg";
import { setCookie, getCookie, deleteCookie } from "../../utils/utils";
import { makeAPICall } from "../../services/apiService";
import PageLoader from "src/atoms/pageLoader";

const ApplyCouponSearch = () => {
  const history = useHistory();
  const [openLogoutModal, setLogoutModal] = useState(false);
  const [orderIdText, setOrderIdText] = useState("");
  const [idInputClass, setIdInputClass] = useState("");
  const [orderIdTxtValid, setOrderIdTxtValid] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [ordersList, setOrdersList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOrderDetails, setSelectedOrderDetails] = useState({});
  const [disabled, setDisabled] = useState(false);
  const { search } = useLocation();

  const openMenu = Boolean(anchorEl);
  let offlinepayment = new URLSearchParams(search).get("offinepayment");

  useEffect(() => {
    deleteCookie(["offline_unique_code"]);
  }, []);

  const orderIdTextChange = (e) => {
    if (e.target.value) {
      const maxInputRegex = /^[0-9]{0,10}$/;
      if (
        e.target.value.length == 10 &&
        !offlinepayment &&
        maxInputRegex.test(e.target.value)
      ) {
        setOrderIdTxtValid(true);
      } else if (e.target.value.length == 6) {
        setOrderIdTxtValid(true);
      } else {
        setIdInputClass("input-green");
        setShowErrorMsg(false);
        setOrderIdTxtValid(false);
      }
      setOrderIdText(e.target.value);
    } else {
      setOrderIdTxtValid(false);
      setOrderIdText("");
      setIdInputClass("");
      setOrdersList([]);
    }
  };

  const orderIdFocus = () => {
    setIdInputClass("input-green");
  };

  const orderIdBlur = () => {
    setIdInputClass("");
  };

  const searchById = () => {
    //it means it is a phone number for apply coupons
    setLoader(true);

    if (orderIdText.length == 10) {
      let config = {
        method: "post",
        url: `api/customer/getUserData`,
        headers: { "Content-Type": "application/json" },
        data: { phone_number: orderIdText },
      };
      makeAPICall(config)
        .then((response) => {
          setLoader(false);
          console.log("response:", response?.data?.data?.user_detail?.name);
          history.push({
            pathname: `/apply-coupon`,
            search: `?ApplyWithNumber=true`,
            state: {
              number: orderIdText,
              name: response?.data?.data?.user_detail?.name || "",
            },
          });
        })
        .catch((e) => {
          setLoader(false);
          history.push({
            pathname: `/apply-coupon`,
            search: `?ApplyWithNumber=true`,
            state: {
              number: orderIdText,
            },
          });
        });
    } else {
      let config = {
        method: "get",
        url: `api/coupon/getOrdersByLastSix`,
        params: {
          orderId: orderIdText,
        },
      };
      if (offlinepayment) {
        config.url = "api/offlinePayment/getOrdersByLastSix";
      }

      makeAPICall(config)
        .then((resp) => {
          console.log(resp, "response on front end");
          if (resp && resp.data.status === "SUCCESSFUL") {
            if (resp.data.data.length !== 0) {
              setOrdersList(resp.data.data);
              setShowErrorMsg(false);
            } else {
              setShowErrorMsg(true);
              setOrdersList([]);
              setIdInputClass("input-error");
            }
          }

          setLoader(false);
        })
        .catch((err) => {
          setShowErrorMsg(true);
          setIdInputClass("input-error");
          setLoader(false);
        });
    }
  };

  async function getUserDetails(selectedOrder) {
    // api call for getting user previous details
    setLoading(true);
    let getuserPreviousDetails = {
      method: "get",
      url: "api/offlinePayment/getOfflinepaymentDetails",
      params: {
        orderId: selectedOrder?.order_id,
        customer_uuid: selectedOrder?.customer_id,
      },
    };

    let getOfflineSplitsPayload = {
      method: "get",
      url: "api/offlinePayment/getOfflineSplits",
      params: {
        orderId: selectedOrder?.order_id,
        customer_uuid: selectedOrder?.customer_id,
      },
    };
    await makeAPICall(getuserPreviousDetails)
      .then(async (resp) => {
        let getOfflineSplitsResp = await makeAPICall(getOfflineSplitsPayload);
        let getOfflineSplits = requiresFreshOfflinePaymentCode(
          getOfflineSplitsResp?.data?.all_payment_transactions
        ) || getOfflineSplitsResp?.data?.ola_care_ew_payment_initiated;
        localStorage.setItem(
          "ola_care_ew_payment_initiated",
          getOfflineSplitsResp?.data?.ola_care_ew_payment_initiated
        );
        console.log(getOfflineSplits, "getOfflineSplits");
        console.log(getOfflineSplitsResp, "getOfflineSplitsResp");
        if (
          getOfflineSplits ||
          resp?.data?.status === "FAILED" ||
          resp?.data?.status === "CREATED"
        ) {
          history.push("/codeOfflinePayment");
        } else if (resp && resp?.data?.status) {
          history.push("/offlinePayment");
        } else {
          history.push("/codeOfflinePayment");
        }
        console.log(resp, "user previous details in 6 digit page");
        setLoading(false);
      })
      .catch((err) => {
        // toggleToaster("Cannot find user details")
        console.log("error in getting user previous data", err);
        setLoading(false);
      });
  }

  const redirectToCouponDetails = (selectedOrder) => {
    if (offlinepayment) {
      sessionStorage.setItem("user_details", JSON.stringify(selectedOrder));
      getUserDetails(selectedOrder);
      return;
    }
    setSelectedOrderDetails(selectedOrder);
    setDisabled(true);
    console.log(selectedOrder, "selectedOrder");

    history.push({
      pathname: `/apply-coupon`,
      search: `?orderId=${selectedOrder.order_id}`,
      state: {
        ...selectedOrder,
      },
    });
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const onCloseMenu = () => {
    setAnchorEl(null);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setLogoutModal(true);
  };

  const completeLogout = () => {
    let logoutconfig = {
      method: "put",
      url: `/api/user/logout`,
      headers: {
        oem_auth_token: getCookie("oem_auth_token"),
      },
      data: {},
    };
    makeAPICall(logoutconfig)
      .then((data) => {
        console.log("Sucess ", data);
        history.push("/phoneNumber");
      })
      .catch((e) => {
        console.log("Fail ", e);
      });

    setAnchorEl(null);
  };

  let bcUserDetails = JSON.parse(localStorage.getItem("bcUserDetails") || "{}");
  return (
    <div className="loan-container">
      {loading && <PageLoader />}
      <div className="header">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Link to="/booking-list">
            <BackArrow removeClass={true} />
          </Link>
          <div className="header-text">
            {offlinepayment ? "Offline payment" : "Apply coupon"}
          </div>
        </div>

        <div>
          <img
            src={UserIcon}
            alt="userIcon"
            onClick={handleClick}
            style={{ "pointer-events": "all" }}
          />
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={openMenu}
            onClose={onCloseMenu}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem onClick={closeMenu} className="menuUI">
              Logout
            </MenuItem>
          </Menu>
        </div>
      </div>
      <div className="inner-container">
        <div className="form-container">
          <div className="loan-inputfield">
            <FloatingInput
              id="orderId"
              name="orderId"
              type="text"
              labelName={
                offlinepayment
                  ? "Enter last 6 digits of order ID"
                  : "Mobile or last 6 digits of order ID"
              }
              inputValue={orderIdText}
              onChange={orderIdTextChange}
              className={`card-number ${idInputClass}`}
              placeholder={
                offlinepayment
                  ? "Enter last 6 digits of order ID"
                  : "Mobile or last 6 digits of order ID"
              }
              onFocus={orderIdFocus}
              onBlur={orderIdBlur}
              maxLength={offlinepayment ? 6 : 10}
              labelStyles={{ color: showErrorMsg ? "#D44C59" : "" }}
            />
            {showErrorMsg && (
              <div className="error-msg-container">
                <span className="error-msg-text">Invalid order ID</span>
              </div>
            )}
          </div>
          {loader ? (
            <button className={`search-disable-button`}>
              <div className="loader-container-np">
                <LoaderLight
                  loaderData={loaderData}
                  loaderStyle="loader-light-np"
                />
              </div>{" "}
            </button>
          ) : (
            <button
              className={
                orderIdTxtValid ? "search-button" : "search-disable-button"
              }
              type="submit"
              onClick={() => searchById()}
            >
              <img src={searchIcon} alt="searchIcon" />
            </button>
          )}
        </div>
        {ordersList.length == 0 ? (
          <div className="no-orders">
            <div
              style={{
                width: 180,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <img
                src={graySearchIcon}
                alt="searchIcon"
                style={{ height: 60, width: 60 }}
              />
              <p style={{ marginLeft : '20px'}}>
                {offlinepayment
                  ? "Enter last 6 digits of order ID"
                  : "Mobile or last 6 digits of order ID"}
              </p>
            </div>
          </div>
        ) : (
          <div>
            {ordersList.map((order) => (
              <div
                className="orderlist-container"
                onClick={() => !disabled && redirectToCouponDetails(order)}
              >
                <div>
                  <div className="order-number">{order.order_id}</div>
                  <div className="user-name">{order.name}</div>
                </div>
                <img
                  src={rightArrow}
                  alt="rightArrow"
                  style={{ height: 30, width: 30 }}
                />
              </div>
            ))}
          </div>
        )}


        <Drawer
          anchor={"bottom"}
          open={openLogoutModal}
          onClose={() => setLogoutModal(false)}
          PaperProps={{
            style: {
              borderRadius: 0,
            },
          }}
        >
          <div className="bc-modal-container">
            <div className="heading-container">
              Are you sure you want to Logout?
            </div>
            <div className="btn-container">
              <button
                onClick={() => setLogoutModal(false)}
                className="cancel-btn"
              >
                Back
              </button>
              <button onClick={() => completeLogout()} className="confirm-btn">
                Yes
              </button>
            </div>
          </div>
        </Drawer>
      </div>
     {offlinepayment && <div className="cashType-div">
          <div
            className="cashType-txt"
            onClick={() => {
              history.push("/cash-type");
            }}
          >
            View Pending / Failed Cash Transaction
          </div>
        </div>}
    </div>
  );
};

export default ApplyCouponSearch;
